import { Fill, Stroke, Style, Text } from "ol/style";
import CircleStyle from "ol/style/Circle";

const vectorStyles = {
  Point: new Style({
    image: new CircleStyle({
      radius: 5,
      fill: null,
      stroke: new Stroke({ color: "red", width: 1 }),
    }),
  }),
  LineString: new Style({
    stroke: new Stroke({
      color: "green",
      width: 1,
    }),
  }),
  MultiLineString: new Style({
    stroke: new Stroke({
      color: "green",
      width: 1,
    }),
  }),
  MultiPoint: new Style({
    image: new CircleStyle({
      radius: 5,
      fill: null,
      stroke: new Stroke({ color: "red", width: 1 }),
    }),
  }),
  MultiPolygon: new Style({
    stroke: new Stroke({
      color: "yellow",
      width: 2,
    }),
  }),
  GridNameLabel: new Style({
    text: new Text({
      font: "22px Calibri,sans-serif",
      offsetY: "-30",
      overflow: true,
      fill: new Fill({
        color: "#ffff00",
        width: 2,
      }),
    }),
  }),

  GridStatusLabel: new Style({
    text: new Text({
      font: "20px Calibri,sans-serif",
      overflow: true,
      fill: new Fill({
        color: "#ffff00",
      }),
    }),
  }),
  GridSubStatusLabel: new Style({
    text: new Text({
      font: "18px Calibri,sans-serif",
      overflow: true,
      offsetY: "40",
      fill: new Fill({
        color: "#e1e74f",
      }),
    }),
  }),
  TileLabel: new Style({
    text: new Text({
      font: "18px Calibri,sans-serif",
      overflow: true,
      fill: new Fill({
        color: "#ffff00",
      }),
    }),
  }),

  TileDoneLabel: new Style({
    text: new Text({
      font: "18px Calibri,sans-serif",
      overflow: true,
      fill: new Fill({
        color: "rgba(4,5,16,0.44)",
      }),
    }),
  }),

  Grid: new Style({
    stroke: new Stroke({
      color: "#ffff00",
      width: 3,
    }),
    fill: new Fill({
      color: "rgba(255,255,255,0)",
    }),
  }),

  Tile: new Style({
    stroke: new Stroke({
      color: "#ffff00",
      width: 2,
    }),
  }),
  TileDone: new Style({
    stroke: new Stroke({
      color: "rgba(4,5,16,0.44)",
      width: 2,
    }),
  }),

  Speical: new Style({
    stroke: new Stroke({
      color: "#f30404",
      width: 3,
    }),
  }),

  Polygon: new Style({
    stroke: new Stroke({
      color: "blue",
      lineDash: [4],
      width: 3,
    }),
  }),
  GeometryCollection: new Style({
    stroke: new Stroke({
      color: "magenta",
      width: 2,
    }),
    fill: new Fill({
      color: "magenta",
    }),
    image: new CircleStyle({
      radius: 10,
      fill: null,
      stroke: new Stroke({
        color: "magenta",
      }),
    }),
  }),
};
export default vectorStyles;
